import type { NavigationGuard, RouteConfig, } from 'vue-router';

function loadNavigationGuard(name: keyof typeof import('./route-guards')): NavigationGuard {
	return (to, from, next) => {
		import('./route-guards').then((a) => {
			a[name](to, from, next);
		});
	};
}

export const ChangeEmailAddressRoutes: RouteConfig[] = [
	{
		path: '/change-email-address',
		component: () => import('./pages/master.vue').then((m) => m.default),
		children: [
			{ path: `enter-email-address`, name: 'ChangeEmailAddress', component: () => import('./pages/index.vue').then((m) => m.default), },
			{ path: `check-and-confirm`, name: 'CheckAndConfirm', component: () => import('./pages/check-and-confirm.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresUserNewEmail'), },
			{ path: `verification-pending`, name: 'EmailVerificationPending', component: () => import('./pages/email-verification-pending.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresUserNewEmail'), },
			{ path: `email-verification`, name: 'EmailVerificationStatus', component: () => import('./pages/email-verification-status.vue').then((m) => m.default), },
			{ path: '', redirect: 'enter-email-address', },
		],
	},
];
